import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import * as React from "react";

import { useAnalytics } from "@/providers";
import {
  EventName,
  ComponentPropsWithEvent,
} from "@/shared/services/analytics";

type RobotoLoadingButtonPropsWithEvent<T extends EventName> =
  ComponentPropsWithEvent<T, LoadingButtonProps>;

// This function type overload provides better intellisense by telling the author
// what field is missing from the event properties. Without this, it'll just say
// "Your value for eventProperties does not match the expected type."
export function RobotoLoadingButton<T extends EventName>(
  props: RobotoLoadingButtonPropsWithEvent<T>,
): JSX.Element;

export function RobotoLoadingButton(
  props: Partial<RobotoLoadingButtonPropsWithEvent<EventName>>,
): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { onClick, eventName, eventProperties, ...buttonProps } = props;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (eventName) {
      trackEvent(eventName, eventProperties);
    }
    onClick?.(event);
  };

  return (
    <LoadingButton
      disableElevation
      onClick={handleClick}
      style={{ textTransform: "none" }}
      {...buttonProps}
    >
      {props.children}
    </LoadingButton>
  );
}
